import { render, staticRenderFns } from "./Tab7.vue?vue&type=template&id=0a6b8e2e&scoped=true"
import script from "./Tab7.vue?vue&type=script&lang=js"
export * from "./Tab7.vue?vue&type=script&lang=js"
import style0 from "./Tab7.vue?vue&type=style&index=0&id=0a6b8e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b8e2e",
  null
  
)

export default component.exports